import React from 'react';
import css from 'styled-jsx/css';
import BannerDesktopView from './Banner/DesktopView';
import RequirementsDesktopView from './Requirements/DesktopView';
import ReleasesDesktopView from './Releases/DesktopView';
import StylesDesktopView from './Styles/DesktopView';
import RejectedContentDesktopView from './RejectedContent/DesktopView';
import FooterDesktopView from './Footer/DesktopView';
import Materials from './Materials';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';

const DesktopView = ({ t, lng }) => {
  return (
    <div className="submission-guideline-page-desktop-view">
      <BannerDesktopView t={t} lng={lng} />
      {config.isIllustAC() && <Materials t={t} lng={lng} />}
      <RequirementsDesktopView t={t} lng={lng} />
      {config.isPhotoAC() && <ReleasesDesktopView t={t} lng={lng} />}
      {config.isIllustAC() && <StylesDesktopView t={t} lng={lng} />}
      <RejectedContentDesktopView t={t} lng={lng} />
      <FooterDesktopView t={t} lng={lng} />
      <style jsx>{styles}</style>
    </div>
  );
};

const styles = css`
  .submission-guideline-page-desktop-view {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: #fff;
    padding-top: 80px;
  }

  @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
    .submission-guideline-page-desktop-view {
      display: none;
    }
  }
`;

export default DesktopView;
